export function initialize_select2(root = document) {
  const $ = window.rebredgVendors?.select2Jquery;
  if (!$?.fn?.select2) return;

  root.querySelectorAll('.rebredg-cf7-form select').forEach((select) => {
    if (select.dataset.select2Initialized === 'true') return;

    const field = select.closest('.rebredg-form-field') || select.parentElement;
    const placeholderOption = [...select.options].find((option) => !option.value || option.value === '0');

    $(select).select2({
      width: '100%',
      placeholder: select.dataset.placeholder || placeholderOption?.textContent?.trim() || '',
      closeOnSelect: !select.multiple,
      dropdownParent: field ? $(field) : undefined,
      minimumResultsForSearch: select.multiple ? Infinity : 8,
    });

    const updateMultipleState = () => {
      if (!select.multiple || !field) return;

      const values = $(select).val();
      const hasSelection = Array.isArray(values) ? values.length > 0 : Boolean(values);

      field.classList.toggle('has-selection', hasSelection);

      const inlineSearch = field.querySelector('.select2-search--inline');
      if (inlineSearch) {
        inlineSearch.remove();
      }

      const selection = field.querySelector('.select2-selection--multiple');
      if (selection) {
        selection.setAttribute('tabindex', '0');
        selection.setAttribute(
          'aria-label',
          field.dataset.label || select.getAttribute('aria-label') || 'Choose options'
        );
      }
    };

    if (select.multiple && field) {
      updateMultipleState();

      $(select)
        .on('select2:open', () => {
          field.classList.add('is-active');

          window.requestAnimationFrame(() => {
            field.querySelector('.select2-search--inline')?.remove();
          });
        })
        .on('select2:close', () => {
          field.classList.remove('is-active');
        })
        .on('select2:select select2:unselect change', updateMultipleState);

      field.addEventListener('keydown', (event) => {
        const selection = event.target.closest?.('.select2-selection--multiple');
        if (!selection) return;

        if (['Enter', ' ', 'ArrowDown'].includes(event.key)) {
          event.preventDefault();
          $(select).select2('open');
        }

        if (event.key === 'Escape') {
          $(select).select2('close');
        }
      });
    }

    const syncSelect2 = () => {
      $(select).trigger('change.select2');
      updateMultipleState();
    };

    const observer = new MutationObserver(syncSelect2);
    observer.observe(select, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-busy'],
      childList: true,
      subtree: true,
    });

    select.dataset.select2Initialized = 'true';
  });
}
